import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    form: 'mt-8 flex flex-col gap-3'
  }
});
